import { Stack } from "@mui/material";
import numeral from "numeral";
import { FC } from "react";
import type { CustomHeaderProps } from "ag-grid-react";
import { TooltipText } from "@/components/common/TooltipText";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

interface InnerHeaderComponentParamsProps {
  trend: number | null;
}

export const BillingExplorerWidgetTrendHeaderCell: FC<
  CustomHeaderProps<ResourceExplorerGridDataWithId>
> = ({ innerHeaderComponentParams, ...props }) => {
  const { trend }: InnerHeaderComponentParamsProps =
    innerHeaderComponentParams ?? {};
  const plusSign = trend && trend > 0 ? "+" : "";

  return (
    <Stack width="100%" position="relative" alignItems="flex-end">
      <TooltipText
        width="100%"
        variant="body2"
        fontWeight="medium"
        sx={ellipsisStyles}
        tooltipPlacement="top"
        tooltipTitle="Total Cost compared with Previous Period Cost."
      >
        {props.displayName}
      </TooltipText>

      <TypographyWithTooltip
        fontSize={10}
        variant="caption"
        title={trend ? `${plusSign}${numeral(trend).format("0.00")}%` : "N/A"}
      />
    </Stack>
  );
};

const ellipsisStyles = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
};
